import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "@/components/motion/Reveal";

// Fotografía de Pexels (licencia libre, uso comercial sin atribución).
const CTA_IMG =
    "https://images.pexels.com/photos/8066082/pexels-photo-8066082.jpeg?auto=compress&cs=tinysrgb&w=1600";

export default function CtaFinal() {
    return (
        <section
            id="crear"
            data-testid="home-cta-final"
            className="relative isolate overflow-hidden py-24 sm:py-32"
        >
            <img
                src={CTA_IMG}
                alt=""
                loading="lazy"
                decoding="async"
                width="1600"
                height="1067"
                className="absolute inset-0 -z-10 w-full h-full object-cover"
            />
            {/* Velo plano del color de marca sobre un oscurecido neutro: la
                textura del taller se sigue leyendo debajo, sin degradado.
                En estilo en línea por la misma razón que el velo del hero: el
                modificador de opacidad suelto de Tailwind solo acepta múltiplos
                de 5, y /88 se descartaba sin avisar. */}
            <div
                aria-hidden="true"
                className="absolute inset-0 -z-10"
                style={{ backgroundColor: "rgba(11,11,14,0.25)" }}
            />
            <div
                aria-hidden="true"
                className="absolute inset-0 -z-10"
                style={{ backgroundColor: "rgba(55,48,163,0.34)" }}
            />

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2
                    className="text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-[-0.03em] leading-[1.02] text-white"
                    style={{
                        textShadow:
                            "0 1px 2px rgba(0,0,0,0.45), 0 10px 40px rgba(0,0,0,0.45)",
                    }}
                >
                    <Reveal variant="mask">Tu tienda puede estar lista hoy</Reveal>
                </h2>
                <Reveal delay={0.1}>
                    <p
                        style={{ textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}
                        className="mt-5 text-lg text-white/85 leading-relaxed max-w-xl mx-auto"
                    >
                        Crea tu tienda en línea gratis y empieza a vender con
                        pagos y envíos resueltos desde el primer día.
                    </p>
                    <Button
                        data-testid="cta-final-create-store"
                        asChild
                        className="group mt-10 h-14 px-9 rounded-full text-base font-semibold bg-white text-[#1A1A1A] hover:bg-zinc-100 shadow-xl shadow-black/25 transition-transform active:scale-[0.98]"
                    >
                        <Link to="/registro?rol=merchant">
                            Crear mi tienda gratis
                            <ArrowRight
                                className="w-4 h-4 ml-1.5 transition-transform duration-200 group-hover:translate-x-0.5"
                                aria-hidden="true"
                            />
                        </Link>
                    </Button>
                    <p
                        style={{ textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}
                        className="mt-5 text-sm text-white/80"
                    >
                        Sin renta mensual · Sin comisión por venta · Sin tarjeta de crédito
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
